import { render, staticRenderFns } from "./ManageMcqExamQuestions.vue?vue&type=template&id=fdaad986&scoped=true"
import script from "./ManageMcqExamQuestions.vue?vue&type=script&lang=js"
export * from "./ManageMcqExamQuestions.vue?vue&type=script&lang=js"
import style0 from "./ManageMcqExamQuestions.vue?vue&type=style&index=0&id=fdaad986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaad986",
  null
  
)

export default component.exports